import { Button, Form, Modal } from 'antd';
import { useEffect, useState } from 'react';
import { IState, IUserProfile } from '../../../types/api';

import useAuthStore from '../../../store/authStore';
import { ApiKeyInfo } from './components/ApiKeyInfo';
import { BusinessInfoForm } from './components/BusinessInfoForm';
import { PersonalInfoForm } from './components/PersonalInfoForm';
import styles from './UserProfile.module.scss';

interface UserDetailProps {
  close?: () => void;
  downloaderApiKey?: string;
  isKeyValid?: boolean;
  requestApiKey?: () => void;
  subscription: {
    type: string;
    expiredDate: string;
  };
  readOnly: boolean;
  postUpdate?: (values: IUserProfile) => void;
}

export default function UserDetail(props: UserDetailProps) {
  const userProfile = useAuthStore((state) => state.userProfile);
  const [form] = Form.useForm();
  const user = useAuthStore((state) => state.user);

  const [statesList, setStatesList] = useState<IState[]>([]);
  const [credits, setCredits] = useState(0);
  const [openWarnUser, setOpenWarnUser] = useState(false);

  useEffect(() => {
    if (!userProfile) return;

    form.setFieldsValue({
      ...userProfile,
      subscription: props.subscription.type,
      expiredDate: props.subscription.expiredDate,
    });

    setCredits(userProfile.credits ? userProfile.credits : 0);
  }, [userProfile, props.subscription, form]);

  const onFinish = (values: IUserProfile) => {
    if (props.postUpdate) props.postUpdate(values);
    if (props.close) props.close();
  };

  return (
    <>
      <Modal
        title='User is not associated with a company'
        open={openWarnUser}
        onCancel={() => setOpenWarnUser(false)}
        footer={[
          <Button
            key='close'
            type='default'
            onClick={() => setOpenWarnUser(false)}
          >
            Close
          </Button>,
        ]}
      >
        <p>
          Your email address {user.userName}.com is not associated with a
          company. Please contact customer care mike@dhigroup.com to have your
          user profile associated with a company.
        </p>
      </Modal>
      <Form form={form} onFinish={onFinish} layout='vertical'>
        <div className={styles.formWrapper}>
          <PersonalInfoForm
            readOnly={props.readOnly}
            editProfileUrl={userProfile?.editProfileUrl}
          />
          <BusinessInfoForm statesList={statesList} readOnly={props.readOnly} />
        </div>
        <ApiKeyInfo
          credits={credits}
          requestApiKey={props.requestApiKey}
          isKeyValid={props.isKeyValid}
          readOnly={props.readOnly}
          downloaderApiKey={props.downloaderApiKey}
        />
      </Form>
    </>
  );
}
